import { render, staticRenderFns } from "./pasargad-pos-documents.vue?vue&type=template&id=0ec20ac6"
import script from "./pasargad-pos-documents.vue?vue&type=script&lang=js"
export * from "./pasargad-pos-documents.vue?vue&type=script&lang=js"
import style0 from "./pasargad-pos-documents.vue?vue&type=style&index=0&id=0ec20ac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports